export const DEP_INIT_MPL = 18;
